import React, { useState } from 'react';
import { Plus, Warehouse, MapPin, Phone, Mail, UserCircle, ChevronRight, ArrowLeft } from 'lucide-react';
export type Magazzino = {
  id: string;
  name: string;
  address: string;
  city: string;
  zip: string;
  province: string;
  manager: {
    name: string;
    email: string;
    phone: string;
  };
};
export const MAGAZZINI: Magazzino[] = [{
  id: 'WH-ROMA',
  name: 'Magazzino Roma',
  address: 'Via Tiburtina 1066',
  city: 'Roma',
  zip: '00156',
  province: 'RM',
  manager: {
    name: 'Giulia Conti',
    email: 'giulia.conti@aisac.it',
    phone: '+39 06 4140 8200'
  }
}, {
  id: 'WH-BOLOGNA',
  name: 'Magazzino Bologna',
  address: 'Via dell\u2019Industria 22',
  city: 'Bologna',
  zip: '40138',
  province: 'BO',
  manager: {
    name: 'Andrea Rossi',
    email: 'andrea.rossi@aisac.it',
    phone: '+39 051 633 8200'
  }
}];
export function Magazzini() {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const selected = MAGAZZINI.find(m => m.id === selectedId) || null;
  if (selected) {
    return <MagazzinoDetail magazzino={selected} onBack={() => setSelectedId(null)} data-id="element-2039" />;
  }
  return <div className="space-y-6" data-id="element-2040">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-2041">
        <div data-id="element-2042">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2043">
            Magazzini
          </h1>
        </div>
        <button type="button" className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-2044">
          <Plus className="h-4 w-4" data-id="element-2045" />
          Nuovo magazzino
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2046">
        {MAGAZZINI.map(m => <button key={m.id} onClick={() => setSelectedId(m.id)} className="text-left bg-[#181818] border border-[#262626] rounded-xl p-5 hover:border-[#333] transition group" data-id="element-2047">
            <div className="flex items-start gap-3" data-id="element-2048">
              <div className="h-10 w-10 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-2049">
                <Warehouse className="h-5 w-5 text-[#D4FF3A]" data-id="element-2050" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-2051">
                <div className="flex items-center gap-2 flex-wrap" data-id="element-2052">
                  <span className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-2053">
                    {m.name}
                  </span>
                  <span className="text-[10px] font-mono text-[#6B6B6B]" data-id="element-2054">
                    {m.id}
                  </span>
                </div>
                <div className="text-xs text-[#9A9A9A] mt-1 flex items-center gap-1.5" data-id="element-2055">
                  <MapPin className="h-3 w-3 text-[#6B6B6B]" data-id="element-2056" />
                  {m.address}, {m.zip} {m.city} ({m.province})
                </div>
                <div className="text-xs text-[#9A9A9A] mt-2 flex items-center gap-1.5" data-id="element-2057">
                  <UserCircle className="h-3 w-3 text-[#6B6B6B]" data-id="element-2058" />
                  {m.manager.name}
                </div>
              </div>
              <ChevronRight className="h-4 w-4 text-[#6B6B6B] shrink-0 mt-1 group-hover:text-[#FAFAFA] transition" data-id="element-2059" />
            </div>
          </button>)}
      </div>
    </div>;
}
function MagazzinoDetail({
  magazzino: m,
  onBack
}: {
  magazzino: Magazzino;
  onBack: () => void;
}) {
  return <div className="space-y-6" data-id="element-2060">
      <button onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-[#9A9A9A] hover:text-[#FAFAFA] transition-colors" data-id="element-2061">
        <ArrowLeft className="h-4 w-4" data-id="element-2062" />
        <span data-id="element-2063">Torna ai magazzini</span>
      </button>

      <div className="bg-[#181818] border border-[#262626] rounded-xl p-5" data-id="element-2064">
        <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-2065">
          <div className="flex items-start gap-4" data-id="element-2066">
            <div className="h-12 w-12 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-2067">
              <Warehouse className="h-6 w-6 text-[#D4FF3A]" data-id="element-2068" />
            </div>
            <div data-id="element-2069">
              <div className="text-xs font-mono text-[#9A9A9A] mb-1" data-id="element-2070">
                {m.id}
              </div>
              <h1 className="text-xl font-semibold text-[#FAFAFA] font-heading" data-id="element-2071">
                {m.name}
              </h1>
              <div className="text-sm text-[#9A9A9A] mt-1 flex items-center gap-1.5" data-id="element-2072">
                <MapPin className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-2073" />
                {m.address}, {m.zip} {m.city} ({m.province})
              </div>
            </div>
          </div>
          <button className="px-3 py-1.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-xs text-[#FAFAFA] hover:border-[#333] transition" data-id="element-2074">
            Modifica
          </button>
        </div>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl p-5" data-id="element-2075">
        <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading mb-4" data-id="element-2076">
          Responsabile
        </h3>
        <div className="flex items-start gap-3 mb-4" data-id="element-2077">
          <div className="h-10 w-10 rounded-full bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-2078">
            <UserCircle className="h-5 w-5 text-[#9A9A9A]" data-id="element-2079" />
          </div>
          <div className="min-w-0" data-id="element-2080">
            <div className="text-sm text-[#FAFAFA] font-medium" data-id="element-2081">
              {m.manager.name}
            </div>
            <div className="text-xs text-[#6B6B6B] mt-0.5" data-id="element-2082">
              Referente operativo
            </div>
          </div>
        </div>
        <div className="space-y-2 text-sm" data-id="element-2083">
          <a href={`mailto:${m.manager.email}`} className="flex items-center gap-2 text-[#9A9A9A] hover:text-[#FAFAFA] transition" data-id="element-2084">
            <Mail className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-2085" />
            <span className="truncate" data-id="element-2086">{m.manager.email}</span>
          </a>
          <a href={`tel:${m.manager.phone}`} className="flex items-center gap-2 text-[#9A9A9A] hover:text-[#FAFAFA] transition" data-id="element-2087">
            <Phone className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-2088" />
            {m.manager.phone}
          </a>
        </div>
      </div>
    </div>;
}